<template>
    <div class="banner">
        <div class="banner-bac">
            <div class="swipe">
                <div class="banner-list">
                    <img class="banner-item" :src="item.img" v-for="(item,index) in banner" :key="index"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
const banner = [
  {
    img: require('../img/banner/banner-1.png'),
    id: 0
  },
  {
    img: require('../img/banner/banner-2.png'),
    id: 0
  },
  {
    img: require('../img/banner/banner-3.png'),
    id: 0
  },
  {
    img: require('../img/banner/banner-4.png'),
    id: 0
  },
  {
    img: require('../img/banner/banner-5.png'),
    id: 0
  },
  {
    img: require('../img/banner/banner-6.png'),
    id: 0
  },
  {
    img: require('../img/banner/banner-7.png'),
    id: 0
  },
  {
    img: require('../img/banner/banner-8.png'),
    id: 0
  },
  {
    img: require('../img/banner/banner-9.png'),
    id: 0
  }
]
export default {
  data() {
    return {
      banner
    }
  }
}
</script>
<style lang="less" scoped>
.banner {
  .banner-bac {
    box-sizing: border-box;
    width: 375px;
    height: 689.5px;
    padding-top: 201.5px;
    background: url('../img/banner/5.jpg');
    background-size: 100% 100%;

    .swipe {
      display: inline-block;
      width: 320px;
      height: 213.5px;
      margin: 0 25px;
      overflow-x: scroll;
      overflow-y: hidden;

      .banner-list {
        display: flex;
        width: auto;
      }

      .banner-item {
        flex-shrink: 0;
        width: 123px;
        height: 213.5px;
        margin-left: 18px;
      }
    }

    ::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
  }
}

</style>
